export default __webpack_public_path__ + "static/media/Csa.2c85bf74.jpg";